
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportThCell from "@/modules/Report/components/ReportThCell.vue";
  import {IApp} from "@/interfaces/app.interface";

  @Component({
    components: {
      ReportThCell,
    }
  })
  export default class ReportTable extends Vue {
    @Prop() dataProps: IReport.ITableProp[];
    @Prop() customComponents!: Record<string, Vue.Component>;

    propType = IApp.SortingPropType;

    get tableList(): IReport.ReportType { return this.$store.getters['report/sortedList'].array; }
    get reportName(): IReport.ReportName { return this.$store.state.report.activeReport; };

    get appTableV2() {
      // let storageValue = localStorage.getItem(IApp.LocalStorageKeys.AppTableV2);
      // return storageValue ? JSON.parse(storageValue) : false;
      return [IReport.ReportName.Movement].includes(this.reportName);
    }

    async cellClick(cell: IReport.ITableProp, item: any, rowIndex: number) {
      if (cell.actionClick) {
        await cell.actionClick(item, rowIndex);
      }
    }
  }
